import { PlusCircleIcon } from '@phosphor-icons/react';
import { Field, FieldArray, useFormikContext } from 'formik';
import { CustomSelect } from 'src/components';
import FormikDatepicker from 'src/components/datepicker/FormikDatepicker';
import TextField from 'src/components/text-field';

interface PaymentSectionProps {
  qrData: { id: string; name: string }[];
  isEdit: boolean;
}

const PaymentSection: React.FC<PaymentSectionProps> = ({ qrData, isEdit }) => {
  const { values } = useFormikContext<any>();

  return (
    <FieldArray name="payments">
      {({ push, remove }) => (
        <div className="w-full h-fit p-2 flex flex-col gap-6 border border-[#F1F0F6] rounded-xl mb-4">
          {/* Payment Rows */}
          {values.payments.map((payment: any, i: number) => (
            <div
              key={i}
              className="p-2 border border-[#F1F0F6] rounded-xl flex flex-col gap-3"
            >
              <TextField
                name={`payments[${i}].amount`}
                label="Payment Amount"
                type="number"
              />
              <FormikDatepicker
                name={`payments[${i}].date`}
                label="Payment Date & Time"
                showTime={true}
              />
              {/* <Field
                name={`payments[${i}].methodId`}
                options={qrData.map((m) => ({ value: m.id, label: m.name }))}
                component={CustomSelect}
                isMulti={false}
                label="Payment Method"
              /> */}
              <Field
                name={`payments[${i}].methodId`}
                className="mt-3"
                options={qrData}
                component={CustomSelect}
                isMulti={false}
                label="Payment Method"
                defaultValue={
                  isEdit
                    ? qrData.find(q => q.id === payment.methodId)?.name // pass label, not ID
                    : undefined
                }
              />
              <button
                type="button"
                onClick={() => remove(i)}
                className="text-red-500 text-sm self-end"
              >
                Remove
              </button>
            </div>
          ))}

          {/* Add Payment Button */}
          <div
            onClick={() =>
              push({
                amount: '',
                date: new Date(),
                methodId: '',
              })
            }
            className="border border-dashed border-border-color-dark flex cursor-pointer
            py-3 rounded-[5px] justify-center items-center text-secondary-0 gap-2"
          >
            <PlusCircleIcon />
            <span>Add payment section</span>
          </div>
        </div>
      )}
    </FieldArray>
  );
};

export default PaymentSection;
